import {ExposedCallbacks} from '@/configurator/embedding/exposed-callbacks';

const EmbeddingCallbacksPlugin = {
  install(Vue: any) {
    Vue.prototype.$embeddingCallbacks = new ExposedCallbacks();
  },
};

export default EmbeddingCallbacksPlugin;
